import request from '@/umi-request';
import { AxiosPromise, } from 'axios';
import { DNI, DetailError, DNIimage } from '@/interfaces/dni';
import { Note } from '@/interfaces/note';
import { PaginatedResponse } from '@/interfaces/response';
import { safeRequest } from './user.service';

export async function uploadDNI(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/dni/`, 
    method: 'POST',
    data
  }) as AxiosPromise<DNI>;
}

export async function uploadImageUpload(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/dni/upload-image/`,
    method: 'POST',
    data 
  }) as AxiosPromise<DNIimage>;
}

export async function cancelDNI(
  affiliate: number,
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `affiliates/${affiliate}/dni/${id}/cancel/`,
    method: 'POST'
  });
}

export function updateDNI(affiliate: number, id: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/dni/${id}/update/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<DNI>
}

export async function queryDNIs(params: any = {}) {
  return request({
    url: 'dni/',
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<DNI>>;
}

export function queryDNI(id: number | string) {
  return request({
    url: `dni/${id}/`,
    method: 'GET',
  }) as AxiosPromise<PaginatedResponse<DNI>>;
}

export function updateDNIStatus(id: number | string, data: any) {
  return request({
    url: `dni/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<DNI>;
}

export function queryDNIChangesHistory(id: number | string) {
  return request({
    url: `dni/${id}/changes-history/`,
    method: 'GET',
  }) as AxiosPromise<PaginatedResponse<DNI[]>>;
}

export function queryDNIHistory(id: number | string) {
  return request({
    url: `dni/${id}/history/`,
    method: 'GET',
  }) as AxiosPromise<PaginatedResponse<DNI[]>>;
}

export function sendDNINote(id: number | string, data: { content: string }) {
  return request({
    url: `dni/${id}/notes/`,
    method: 'POST',
    data
  }) as AxiosPromise<Note<DNI>>;
}

export function getDNINotes(
  id: number | string
) {
  return request({
    url: `dni/${id}/notes/`,
    method: 'GET',
  }) as AxiosPromise<Note<DNI>[]>;
}
